module.exports = __webpack_public_path__ + "img/03mazda-cx50.c01d7933.png";